import { RoutesService, eLayoutType } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const ARTWORK_SHARE_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/share/artwork',
        name: 'Artwork Share',
        layout: eLayoutType.empty,
        invisible: true, // Don't show in menu
      },
    ]);
  };
}
